import { useBusinessAddressQuery } from 'hooks/queries/useBusinessAddressQuery'

export interface FinpromData {
  isFetchedFinpromData: boolean
  companyCountryCode: string
  refetchFinpromData: () => {}
}

export const useFinpromData = (isFinpromEnabled: boolean): FinpromData => {
  const {
    data: businessAddress,
    isFetched: isFetchedBusinessAddress,
    refetch: refetchBusinessAddress,
  } = useBusinessAddressQuery(isFinpromEnabled)

  const refetchFinpromData = () => refetchBusinessAddress()

  return {
    isFetchedFinpromData: isFetchedBusinessAddress,
    companyCountryCode: businessAddress?.countryCode,
    refetchFinpromData,
  }
}
